import React from 'react';

const CandlestickChart = ({ data, width, height, yAxisId }) => {
  if (!data || data.length === 0) return null;

  // 计算价格范围
  const prices = data.flatMap(d => [d.high, d.low]);
  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);
  const priceRange = maxPrice - minPrice;
  const padding = priceRange * 0.1;
  const chartMinPrice = minPrice - padding;
  const chartMaxPrice = maxPrice + padding;
  const chartPriceRange = chartMaxPrice - chartMinPrice;

  // 图表尺寸
  const chartWidth = width - 80; // 留出Y轴空间
  const chartHeight = height - 40; // 留出X轴空间
  const candleWidth = Math.max(2, chartWidth / data.length - 2);

  // 价格到Y坐标的转换
  const priceToY = (price) => {
    return chartHeight - ((price - chartMinPrice) / chartPriceRange) * chartHeight + 20;
  };

  return (
    <svg width={width} height={height} className="candlestick-chart">
      {/* 背景网格线 */}
      <defs>
        <pattern id="grid" width="40" height="20" patternUnits="userSpaceOnUse">
          <path d="M 40 0 L 0 0 0 20" fill="none" stroke="#374151" strokeWidth="0.5" opacity="0.3"/>
        </pattern>
      </defs>
      <rect width={chartWidth} height={chartHeight} x="40" y="20" fill="url(#grid)" />

      {/* 蜡烛图 */}
      {data.map((candle, index) => {
        const x = 40 + (index * chartWidth) / data.length + (chartWidth / data.length - candleWidth) / 2;
        const openY = priceToY(candle.open);
        const closeY = priceToY(candle.close);
        const highY = priceToY(candle.high);
        const lowY = priceToY(candle.low);
        
        const isGreen = candle.close >= candle.open;
        const bodyHeight = Math.abs(closeY - openY);
        const bodyY = Math.min(openY, closeY);
        
        return (
          <g key={index}>
            {/* 影线 */}
            <line
              x1={x + candleWidth / 2}
              y1={highY}
              x2={x + candleWidth / 2}
              y2={lowY}
              stroke={isGreen ? '#10B981' : '#EF4444'}
              strokeWidth="1"
            />
            
            {/* 实体 */}
            <rect
              x={x}
              y={bodyY}
              width={candleWidth}
              height={Math.max(bodyHeight, 1)}
              fill={isGreen ? '#10B981' : '#EF4444'}
              opacity={isGreen ? 0.8 : 1}
              stroke={isGreen ? '#10B981' : '#EF4444'}
              strokeWidth="1"
            />
          </g>
        );
      })}

      {/* Y轴标签 */}
      {[0, 0.25, 0.5, 0.75, 1].map(ratio => {
        const price = chartMinPrice + chartPriceRange * ratio;
        const y = priceToY(price);
        return (
          <g key={ratio}>
            <line x1="35" y1={y} x2="40" y2={y} stroke="#9CA3AF" strokeWidth="1" />
            <text
              x="30"
              y={y + 4}
              textAnchor="end"
              fontSize="10"
              fill="#3B82F6"
            >
              ${price.toFixed(0)}
            </text>
          </g>
        );
      })}

      {/* X轴标签 */}
      {data.filter((_, index) => index % 4 === 0).map((candle, index) => {
        const originalIndex = index * 4;
        const x = 40 + (originalIndex * chartWidth) / data.length + chartWidth / data.length / 2;
        return (
          <text
            key={originalIndex}
            x={x}
            y={height - 5}
            textAnchor="middle"
            fontSize="10"
            fill="#9CA3AF"
          >
            {candle.time}
          </text>
        );
      })}
    </svg>
  );
};

export default CandlestickChart;
